import { SET_NCAP_ENABLED, SET_SYSTEM_SETTINGS_STATUS } from '../actionTypes';
import { APP_STATUS } from 'types/app';

export const setNcapEnabled = (enabled: boolean) => ({
  type: SET_NCAP_ENABLED,
  payload: enabled,
});

export const setSystemSettingsStatus = (status: APP_STATUS) => ({
  type: SET_SYSTEM_SETTINGS_STATUS,
  payload: status,
});

